<div [ngClass]="'submenu-simple-left'">
    <nav class="nav">
        <div class="d-flex flex-column gap-3 justify-content-center my-auto w-100">
            
                <nav-item
                    label="Reports"
                    [hideChevronRight]="true">
                    <svg-icon
                        key="project"
                        fontSize="1.5rem"></svg-icon>
                </nav-item>
            
        </div>
    </nav>
</div>
